var __jsx = React.createElement;
import React from "react";
import useIsMobile from "@hooks/useIsMobile";
export var CarSaleCardSkeleton = function CarSaleCardSkeleton() {
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-wrapper",
    className: "w-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-mobile",
    className: "relative overflow-hidden w-full lg:hidden min-h-[345px] px-2"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-mobile-card",
    className: "bg-white rounded-[12px] border border-[#D6DFE9] shadow-md p-2 min-h-[305px] animate-pulse"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-mobile-header",
    className: "flex items-start justify-between mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-mobile-logo",
    className: "w-16 h-16 bg-gray-200 rounded-lg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-mobile-title",
    className: "h-5 bg-gray-200 rounded w-32 mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-mobile-subtitle",
    className: "h-4 bg-gray-200 rounded w-24"
  })))), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-mobile-actions",
    className: "space-y-2"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-mobile-action-1",
    className: "h-20 bg-gray-200 rounded-lg w-full"
  }), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-mobile-action-2",
    className: "h-20 bg-gray-200 rounded-lg w-full"
  })))), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop",
    className: "hidden lg:block overflow-visible",
    style: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: "0 80px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-container",
    style: {
      maxWidth: "915px",
      width: "915px",
      margin: "0 auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-card",
    className: "bg-white rounded-[12px] border border-[#D6DFE9] shadow-lg px-8 py-4 min-h-[370px] animate-pulse"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-header",
    className: "flex items-start justify-between mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-logo",
    className: "w-20 h-20 bg-gray-200 rounded-lg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-title",
    className: "h-6 bg-gray-200 rounded w-48 mb-3"
  }), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-subtitle",
    className: "h-5 bg-gray-200 rounded w-32"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-badge",
    className: "h-10 bg-gray-200 rounded-full w-32"
  })), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-actions",
    className: "space-y-3"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-action-1",
    className: "h-20 bg-gray-200 rounded-lg w-full"
  }), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-desktop-action-2",
    className: "h-20 bg-gray-200 rounded-lg w-full"
  }))))), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-skeleton-nav",
    className: "flex items-center justify-center gap-6 mt-8"
  }));
};